const ArrowLeft = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="49" viewBox="0 0 26 49">
      <g fill="none" fillRule="evenodd">
        <g stroke="#979797">
          <path d="M381.432 2144L356.932 2168.5 381.432 2193" transform="translate(-356 -2144)" />
        </g>
      </g>
    </svg>
  );
};

export default ArrowLeft;
